const COLOR_JOB = '#ffe1a6';
const COLOR_GESUND = '#b0efbc';
const COLOR_ICH = '#9bd4ed';
const COLOR_SOZIAL = '#eac0f0';
const COLOR_ENTWICKLUNG = '#efb1b2';
const COLOR_B6="#97A2FF";
const COLOR_B7="#FFC9DE";
const COLOR_B8 = "#FFCBC1";
const COLOR_B9 = "#E7FFAC";
const COLOR_B10 = "#E7ACFF";

const NAME_JOB = 'Job';
const NAME_GESUND = 'Gesundheit';
const NAME_ENTWICKLUNG = 'Entwicklung';
const NAME_SOZIAL = 'Soziales Umfeld';
const NAME_ICH = 'Ich';

const colors_by_name = {};
colors_by_name[NAME_JOB] = COLOR_JOB;
colors_by_name[NAME_GESUND] = COLOR_GESUND;
colors_by_name[NAME_SOZIAL] = COLOR_SOZIAL;
colors_by_name[NAME_ENTWICKLUNG] = COLOR_ENTWICKLUNG;
colors_by_name[NAME_ICH] = COLOR_ICH;
colors_by_name["b6"] = COLOR_B6;
colors_by_name["b7"] = COLOR_B7;
colors_by_name["b8"] = COLOR_B8;
colors_by_name["b9"] = COLOR_B9;
colors_by_name["b10"] = COLOR_B10;

export default {
    NAME_JOB, NAME_GESUND, NAME_SOZIAL, NAME_ENTWICKLUNG, NAME_ICH,
    COLOR_JOB, COLOR_GESUND, COLOR_SOZIAL, COLOR_ENTWICKLUNG, COLOR_ICH,
    BIDS: [NAME_JOB, NAME_GESUND, NAME_SOZIAL, NAME_ENTWICKLUNG, NAME_ICH, "b6", "b7", "b8", "b9", "b10"],
    // NAMES is identical to BIDS and is obsolete
    NAMES: [NAME_JOB, NAME_GESUND, NAME_SOZIAL, NAME_ENTWICKLUNG, NAME_ICH, "b6", "b7", "b8", "b9", "b10"],
    ABBR: ['Job', 'Gesund.', 'Soz.U.', 'Entw.', 'Ich'],
    COLORS: [COLOR_JOB, COLOR_GESUND, COLOR_SOZIAL, COLOR_ENTWICKLUNG, COLOR_ICH, COLOR_B6, COLOR_B7, COLOR_B8, COLOR_B9, COLOR_B10],
    // actually colors by BID
    COLORS_BY_NAME: colors_by_name,

    // calc the weights for every lebenssäule so that they sum up to 1
    getWeights(emx, numAllowed){
        var weights={};
        var total=0;
        var n=0;
        numAllowed = numAllowed ? numAllowed : 5;
        for(var b of emx.bereiche || []) {
            if (b.ignore)
                continue;
            if (b.value===undefined)
                b.value=50;
            if (b.value < 0)
                b.value=0;
            if (b.value > 100)
                b.value=100;
            total=total+b.value;
            n++;
            if (n >= numAllowed)
                break;
        }
        if (n==0)
            return weights;
        var i=0;
        if (total==0) {
            for(var b of emx.bereiche || []) {
                weights[b.bid]=b.ignore ? 0 : 100.0/n;
                i++;
                if (i >= numAllowed)
                    break;
            }
            return weights;
        }
        i=0;
        var factor=1.0/total;
        for(var b of emx.bereiche || []) {
            weights[b.bid] = b.ignore ? 0 : b.value * factor;
            i++;
            if (i >= numAllowed)
                break;
        }
        return weights;
    }
}